import React, { Component } from 'react';

import './HeaderSection.scss';

export default class HeaderSection extends Component {
  render() {
    const { children, title, isHeader, isBlack, isNoUnderline } = this.props;
    return (
      <div className={`HeaderSection ${isHeader ? 'header' : ''} ${isBlack ? 'header-color-black' : ''} ${isNoUnderline ? 'no-underline' : ''}`}>
        {title}
        {children}
      </div>
    );
  }
}
